const styles = (theme) => ({
  root: {
    '&:hover .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
});

export default styles;
